function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
  Requirements changed along the way so this component needed a revamp. To allow
  backwards compatibility this new version of the original component was created.
  The original QuantityCounter doesn't allow the user to make mistakes (e.g. insert
  invalid numbers). This one allows full freedom for the user to input any values.

  Also, the way the error message is being injected also changed.
  With the custom validation, the parent can decide when an error occurs, and the
  correspondent error message, which will then be handled by this component's state
*/

import React, { Component } from 'react';
import { string, number, func, bool } from 'prop-types';
import { hasCorrectValidationFormat } from './helpers';
import { button } from '../../styles/colors';
import Icon from '../Icon';
import { PlusIcon, MinusIcon, CartIcon } from '../Icons';
import { Input, StyledButton, PlusButton, MinusButton, QuantityButton, Wrapper, MicroWrapper, ElementWrapper, ErrorMessage } from './styles';
var QuantityCounterV2 = /*#__PURE__*/function (_Component) {
  _inherits(QuantityCounterV2, _Component);
  var _super = _createSuper(QuantityCounterV2);
  function QuantityCounterV2(props) {
    var _this;
    _classCallCheck(this, QuantityCounterV2);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      var contentContainsTarget = function contentContainsTarget(target) {
        return _this.wrapperRef.current && _this.wrapperRef.current.contains(target);
      };
      if (!contentContainsTarget(e.target)) {
        _this.closeCounter();
      }
    });
    /*
      The user should only be able to press the '-' button if the value is not
      equal to the minimum possible (multiplier)
    */
    _defineProperty(_assertThisInitialized(_this), "canDecrement", function (value, multiplier) {
      return value > multiplier;
    });
    /*
      The user should only be able to press the '+' button if the value + the multiplier is not
      bigger than the maximun number of digits allowed.
    */
    _defineProperty(_assertThisInitialized(_this), "canIncrement", function (value, multiplier, maxDigits) {
      var nextValue = Number((value + multiplier).toFixed(3));
      var nextValueRounded = Math.round(nextValue);
      if (nextValueRounded.toString().length <= maxDigits) {
        return true;
      }
      return false;
    });
    /* Main method to validate input (onChange and onBlur) */
    _defineProperty(_assertThisInitialized(_this), "handleValidation", function (value) {
      var _this$props = _this.props,
        multiplier = _this$props.multiplier,
        customValidation = _this$props.customValidation,
        maxDigits = _this$props.maxDigits;

      // If the parent injects its own validation, it should override the default one.
      if (customValidation && hasCorrectValidationFormat(customValidation, value)) {
        return customValidation(value);
      }
      if (value <= 0) {
        return {
          hasError: true,
          message: "Minimum of ".concat(multiplier, " required")
        };
      }
      if (Math.floor(value.toFixed(maxDigits) % multiplier.toFixed(maxDigits)) !== 0) {
        return {
          hasError: true,
          message: "Multiple of ".concat(multiplier, " required")
        };
      }
      return {
        hasError: false,
        message: null
      };
    });
    /* Responsible for updating the state and calling the parent onChange handler */
    _defineProperty(_assertThisInitialized(_this), "updateValue", function (value) {
      var _this$props2 = _this.props,
        multiplier = _this$props2.multiplier,
        onChange = _this$props2.onChange,
        maxDigits = _this$props2.maxDigits;
      var valueAsNumber = parseFloat(value);
      var inputIsEmpty = isNaN(valueAsNumber); // eslint-disable-line no-restricted-globals
      var error = _this.handleValidation(valueAsNumber || 0);
      _this.setState({
        canDecrement: _this.canDecrement(valueAsNumber, multiplier),
        canIncrement: _this.canIncrement(valueAsNumber, multiplier, maxDigits),
        value: inputIsEmpty ? '' : valueAsNumber,
        error: error
      }, function () {
        return onChange({
          value: valueAsNumber,
          error: error
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "incrementCounter", function () {
      var _this$props3 = _this.props,
        multiplier = _this$props3.multiplier,
        maxDigits = _this$props3.maxDigits;
      var value = _this.state.value;

      // exactRest is a a calculation of the values times 1000 and divided by 1000 to avoid the issue when the division reminder
      // exactly the same as the multiplier, because
      var exactRest = Math.floor((value * 1000).toFixed(maxDigits) % (multiplier * 1000).toFixed(maxDigits) / 1000);
      var valueWithStep = value + multiplier - exactRest;
      // This is required because values with decimals give troubles when JS do precise calculations 76,3 + 152,6 = 228,89999999998
      // With this line we convert the result to 228,9
      var valueWithStepFixed = Number(valueWithStep.toFixed(5));
      if (value.toString().length > maxDigits || value === parseInt('9'.repeat(maxDigits), 10)) {
        return;
      }

      // Set a max limit of digits
      if (value.toString().length === maxDigits) {
        // Edge case where the user inserted the maximum digits but the value is
        // still smaller than the step (e.g 0.0001)
        if (value < multiplier) {
          _this.updateValue(multiplier);
          return;
        }

        // Other edge case where the user already has `maxDigits` inserted but
        // the value is still not the highest possible with that amount of digits.
        if (value < parseInt('9'.repeat(maxDigits), 10)) {
          _this.updateValue(valueWithStepFixed);
          return;
        }
      }
      _this.updateValue(valueWithStepFixed);
    });
    _defineProperty(_assertThisInitialized(_this), "decrementCounter", function () {
      var multiplier = _this.props.multiplier;
      var value = _this.state.value;

      // exactRest is a a calculation of the values times 1000 and divided by 1000 to avoid the issue when the division reminder
      // exactly the same as the multiplier, because
      var exactRest = value * 1000 % (multiplier * 1000) / 1000;
      var valueWithStep;

      // if the division reminder is different than 0, that means that is the amount we need to substract from the value
      if (exactRest === 0) {
        valueWithStep = value - multiplier;
      } else {
        valueWithStep = value - exactRest;
      }
      var valueWithStepFixed = Number(valueWithStep.toFixed(3));
      _this.updateValue(valueWithStepFixed);
    });
    _defineProperty(_assertThisInitialized(_this), "openCounter", function () {
      var onAdd = _this.props.onAdd;
      onAdd();
      _this.setState({
        isOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeCounter", function () {
      _this.setState({
        isOpen: false
      });
    });
    // This function covers the manual change of the vaule in the imput, so not using the + or - buttons.
    // This function could be merged with updateValue but that would mean a major refactor in the other functions and flows.
    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      var _this$props4 = _this.props,
        multiplier = _this$props4.multiplier,
        maxDigits = _this$props4.maxDigits;
      var value = _this.state.value;
      var parsedValue = parseFloat(e.currentTarget.value);
      var canIncrement = _this.canIncrement(parsedValue, multiplier, maxDigits);

      // First we check if the new value is smaller than current value, we do not want to stop the update in that case
      // this cover the case where the value has reach the maximun, canIncrement is false and the user tries to manually decrease the value.
      var isNewValueSmaller = parsedValue < value;
      if (isNewValueSmaller) {
        _this.updateValue(e.currentTarget.value);
      }
      // We don't want the user to be able to increment the value if the maximun has been reached, since canIncrement is initially called to
      // change the state inside updateValue, is already too late to stop the state update for the value since all happens together.
      // That is the reason why an extra check is done here.
      if (canIncrement) {
        _this.updateValue(e.currentTarget.value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleInputOnBlur", function (e) {
      if (e.currentTarget.value === '') {
        _this.updateValue(0);
      } else {
        _this.updateValue(e.currentTarget.value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      if (e.key === 'Enter' || e.keyCode && e.keyCode === '13') {
        _this.updateValue(e.currentTarget.value);
      }
      // This is to avoid allowing the caracters e, +, - which are nativelly accepted.
      if (e.key === 'e' || e.key === '+' || e.key === '-') {
        e.preventDefault();
      }
    });
    _this.wrapperRef = /*#__PURE__*/React.createRef();
    var _multiplier = props.multiplier,
      initialValue = props.initialValue,
      _maxDigits = props.maxDigits;
    var _value = initialValue || _multiplier;
    _this.state = {
      canDecrement: _this.canDecrement(_value, _multiplier),
      canIncrement: _this.canIncrement(_value, _multiplier, _maxDigits),
      value: _value,
      error: _this.handleValidation(_value),
      isOpen: false
    };
    return _this;
  }
  _createClass(QuantityCounterV2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleOutsideClick, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        name = _this$props5.name,
        multiplier = _this$props5.multiplier,
        className = _this$props5.className,
        maxDigits = _this$props5.maxDigits,
        hideMessage = _this$props5.hideMessage,
        disabled = _this$props5.disabled,
        initialValue = _this$props5.initialValue,
        micro = _this$props5.micro,
        rounded = _this$props5.rounded,
        small = _this$props5.small;
      var _this$state = this.state,
        value = _this$state.value,
        _this$state$error = _this$state.error,
        hasError = _this$state$error.hasError,
        message = _this$state$error.message,
        canDecrement = _this$state.canDecrement,
        canIncrement = _this$state.canIncrement,
        isOpen = _this$state.isOpen;
      var inputField = /*#__PURE__*/React.createElement(Input, {
        "data-testid": "counterInput",
        type: "number",
        name: name,
        value: value,
        onBlur: this.handleInputOnBlur,
        onChange: this.handleOnChange,
        onKeyPress: this.handleKeyPress,
        maxLength: maxDigits,
        step: multiplier,
        min: multiplier,
        disabled: disabled,
        micro: micro,
        isOpen: isOpen,
        hasError: hasError,
        small: small
      });
      if (micro) {
        return /*#__PURE__*/React.createElement(MicroWrapper, {
          "data-testid": "".concat(name, "_quantityCounter"),
          message: message,
          className: className,
          hideMessage: hideMessage,
          isOpen: isOpen,
          ref: this.wrapperRef
        }, /*#__PURE__*/React.createElement(MinusButton, {
          id: "".concat(name, "_decrement"),
          "data-testid": "".concat(name, "_decrement"),
          onClick: this.decrementCounter,
          disabled: !canDecrement || disabled,
          variant: "dotprimary",
          isOpen: isOpen
        }, /*#__PURE__*/React.createElement(Icon, {
          as: MinusIcon
        })), inputField, isOpen ? /*#__PURE__*/React.createElement(PlusButton, {
          id: "".concat(name, "_increment"),
          "data-testid": "".concat(name, "_increment"),
          onClick: this.incrementCounter,
          disabled: !canIncrement || disabled,
          variant: "dotprimary"
        }, /*#__PURE__*/React.createElement(Icon, {
          as: PlusIcon
        })) : /*#__PURE__*/React.createElement(QuantityButton, {
          initialValue: initialValue,
          multiplier: multiplier,
          id: "".concat(name, "_add"),
          "data-testid": "".concat(name, "_add"),
          onClick: function onClick(e) {
            return _this2.openCounter(e);
          },
          variant: initialValue && initialValue !== multiplier ? 'dotsecondary' : 'dotprimary'
        }, initialValue && initialValue !== multiplier ? initialValue : /*#__PURE__*/React.createElement(Icon, {
          as: CartIcon
        })));
      }
      return /*#__PURE__*/React.createElement(Wrapper, {
        "data-testid": "quantityCounter",
        message: message,
        className: className,
        hideMessage: hideMessage
      }, /*#__PURE__*/React.createElement(ElementWrapper, {
        hasError: hasError,
        disabled: disabled,
        rounded: rounded,
        small: small
      }, /*#__PURE__*/React.createElement(StyledButton, {
        "data-testid": "decrement",
        onClick: this.decrementCounter,
        disabled: !canDecrement || disabled,
        rounded: rounded,
        small: small
      }, /*#__PURE__*/React.createElement(Icon, {
        as: MinusIcon,
        size: "sz24",
        color: button.primary
      })), inputField, /*#__PURE__*/React.createElement(StyledButton, {
        "data-testid": "increment",
        onClick: this.incrementCounter,
        disabled: !canIncrement || disabled,
        rounded: rounded,
        small: small
      }, /*#__PURE__*/React.createElement(Icon, {
        as: PlusIcon,
        size: "sz24",
        color: button.primary
      }))), hasError && !hideMessage && /*#__PURE__*/React.createElement(ErrorMessage, null, message));
    }
  }]);
  return QuantityCounterV2;
}(Component);
_defineProperty(QuantityCounterV2, "propTypes", {
  name: string.isRequired,
  onChange: func.isRequired,
  onAdd: func,
  multiplier: number,
  initialValue: number,
  maxDigits: number,
  className: string,
  customValidation: func,
  hideMessage: bool,
  disabled: bool,
  micro: bool,
  rounded: bool,
  small: bool
});
_defineProperty(QuantityCounterV2, "defaultProps", {
  onAdd: function onAdd() {
    return null;
  },
  multiplier: 1,
  initialValue: null,
  className: '',
  customValidation: null,
  maxDigits: 5,
  hideMessage: false,
  disabled: false,
  micro: false,
  rounded: false,
  small: false
});
export { QuantityCounterV2 as default };